<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6">
      <h2 class="text-xl font-bold mb-6">{{ job ? 'Edit Job' : 'Add New Job' }}</h2>
      <form @submit.prevent="handleSubmit" class="space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Job ID</label>
            <input
              v-model="formData.jobId"
              :readonly="!!job"
              :class="job ? 'bg-gray-50' : ''"
              required
              class="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Job Title</label>
            <input v-model="formData.title" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Client</label>
            <input v-model="formData.client" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Department</label>
            <v-select
              v-model="formData.department"
              :options="departmentOptions"
              placeholder="Select a department"
              class="mt-1 w-full"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Status</label>
            <select v-model="formData.status" class="mt-1 w-full border rounded px-3 py-2">
              <option value="new">New</option>
              <option value="assigned">Assigned</option>
              <option value="active">Active</option>
              <option value="ended">Ended</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
        </div>

        <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4"> -->
          <div>
            <label class="block text-sm font-medium text-gray-700">Start Location</label>
            <input v-model="formData.startLocation" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">End Location</label>
            <input v-model="formData.endLocation" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
        <!-- </div> -->
        
          <!-- Two Switches -->
          <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div class="flex items-center justify-between border p-3 rounded">
              <div>
                <h4 class="text-sm font-medium text-gray-700">Location Based</h4>
                <p class="text-xs text-gray-500">Enable Assign tracking for this job</p>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input 
                  type="checkbox" 
                  class="sr-only peer" 
                  v-model="formData.locationBased" 
                />
                <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 transition"></div>
                <div
                  class="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition peer-checked:translate-x-5"
                ></div>
              </label>
            </div> -->

            <!-- Notification Switch -->
            <!-- <div class="flex items-center justify-between border p-3 rounded">
              <div>
                <h4 class="text-sm font-medium text-gray-700">Notifications</h4>
                <p class="text-xs text-gray-500">Notify assigned Employee about updates</p>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input 
                  type="checkbox" 
                  class="sr-only peer" 
                  v-model="formData.notifications" 
                />
                <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 transition"></div>
                <div
                  class="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition peer-checked:translate-x-5"
                ></div>
              </label>
            </div> -->
          <!-- </div> -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Job Date</label>
            <input v-model="formData.jobDate" type="date" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <!-- Job Time -->
          <div>
            <label class="block text-sm font-medium text-gray-700">Job Time</label>
            <input 
              v-model="formData.jobTime" 
              type="time" 
              required 
              class="mt-1 w-full border rounded px-3 py-2" 
            />
          </div>
          
          <!-- <div>
            <label class="block text-sm font-medium text-gray-700">Job Start</label>
            <input v-model="formData.jobStart" type="date" required class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Job End</label>
            <input v-model="formData.jobEnd" type="date" required class="mt-1 w-full border rounded px-3 py-2" />
          </div> -->
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4" v-if="this.job">
          <div>
            <label class="block text-sm font-medium text-gray-700">Job Start</label>
            <input v-model="formData.jobStart" type="date" class="mt-1 w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Job End</label>
            <input v-model="formData.jobEnd" type="date" class="mt-1 w-full border rounded px-3 py-2" />
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Description</label>
          <textarea v-model="formData.description" required class="mt-1 w-full border rounded px-3 py-2" />
        </div>

        <div>
  <label class="block text-sm font-medium text-gray-700">Assigned Employee</label>
  <input
    v-model="employeeSearch"
    type="text"
    class="mt-2 w-full border rounded px-3 py-2"
    placeholder="Search employee name..."
    @input="filterEmployees"
    :disabled="formData.assignedEmployees.length > 0"
  />
  <ul v-if="filteredEmployees.length && formData.assignedEmployees.length === 0" class="border rounded mt-1 max-h-40 overflow-y-auto">
    <li
      v-for="emp in filteredEmployees"
      :key="emp.id"
      class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
      @click="selectEmployee(emp)"
    >
      {{ emp.name }}
    </li>
    <li v-if="!filteredEmployees.length" class="px-3 py-2 text-gray-500">
      No results found
    </li>

  </ul>

  <div v-if="formData.assignedEmployees.length > 0" class="mt-4">
    <p class="text-sm text-gray-600">Assigned driver:</p>
    <div class="flex justify-between items-center p-2 bg-gray-50 rounded">
     <span>
        {{
          availableDrivers.find(emp => emp.id === formData.assignedEmployees[0])
            ? availableDrivers.find(emp => emp.id === formData.assignedEmployees[0]).name
            : formData.assignedEmployees[0]
        }}
      </span>


      <button type="button" class="btn btn-sm btn-outline" @click="removeEmployee()">Remove</button>
    </div>
  </div>
</div>



        <div class="flex justify-end space-x-2">
          <button type="button" class="btn btn-outline" @click="onClose">Cancel</button>
          <button type="submit" class="btn btn-dark">
            {{ job ? 'Update' : 'Add' }} Job
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: 'JobForm',
  components: { vSelect},
  props: {
    isOpen: Boolean,
    onClose: Function,
    onSubmit: Function,
    job: Object,
  },
  data() {
    return {
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      formData: {
        jobId: '',
        title: '',
        client: '',
        startLocation: '',
        endLocation: '',
        assignedEmployees: [],
        status: 'new',
        jobDate: '',
        jobStart: '',
        jobEnd: '',
        description: '',
        notifications:false,
        locationBased:false,
        department: "",
      },
      departmentOptions :[],
      employeeInput: '',
      employeeSearch: '',
      filteredEmployees: [],
      availableDrivers: [],  // for drivers search dropdown
      employees: [],         // full employees list
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) this.initializeForm();
    },
    job: {
      immediate: true,
      handler() {
        if (this.isOpen) this.initializeForm();
      },
    },
  },
  methods: {
    /** 🔹 Firebase Auth Helper */
    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            const token = await user.getIdToken();
            resolve(token);
          } else {
            router.push("/");
            reject("Not logged in");
          }
        });
      });
    },

    /** 🔹 Get headers for all API requests */
    async getAuthHeader() {
      const token = await this.checkAuthState();
      return { Authorization: token };
    },

    /** 🔹 Initialize form when opening modal */
    initializeForm() {
       
  
      if (this.job) {
        let assigned = [];

        // 🔹 Try to match backend data to employee IDs
        if (this.job.assignedEmployees && this.job.assignedEmployees.length > 0) {
            const match = this.availableDrivers.find(
              emp => emp.id === this.job.assignedEmployees[0]
            );

            // If not matched by ID but matched by name, we clear it
            if (!match) {
              console.warn("Backend sent name instead of ID:", this.job.assignedEmployees);
              assigned = []; // reset
            } else {
              assigned = this.job.assignedEmployees;
            }
          this.formData = {
            jobId: this.job.jobId,
            title: this.job.title,
            client: this.job.client,
            startLocation: this.job.startLocation,
            endLocation: this.job.endLocation,
            assignedEmployees: assigned,
            status: this.job.status,
            jobDate: this.job.jobDate,
            jobStart: this.job.jobStart,
            jobEnd: this.job.jobEnd,
            description: this.job.description,
            notifications:this.job.notifications,
            locationBased:this.job.locationBased,
            jobTime:this.job.jobTime,

          };
        }
      } else {
        this.formData = {
          jobId: 'JOB-' + String(Date.now()).slice(-8),
          title: '',
          client: '',
          startLocation: '',
          endLocation: '',
          assignedEmployees: [],
          status: 'new',
          jobDate: '',
          jobTime: '',
          jobStart: '',
          jobEnd: '',
          description: '',
          notifications:false,
          locationBased:false,

        };
      }
      this.employeeInput = '';
    },

    /** 🔹 Filter employee search */
    filterEmployees() {
      const keyword = this.employeeSearch.toLowerCase();
      this.filteredEmployees = this.availableDrivers.filter(
        emp =>
          emp.name.toLowerCase().includes(keyword) &&
          !this.formData.assignedEmployees.includes(emp.id)
      );
    },

    /** 🔹 Fetch Employees (Updated as requested) */
    async fetchEmployees() {
      try {
        // Step 1: Get Auth Header
        const headers = await this.getAuthHeader();

        // Step 2: Make API Call
        const response = await axios.get(`${this.apiURL}/api/employees`, { headers });
        const result = response.data;

        // Step 3: Validate Response
        if (result.code !== 200) {
          this.toast?.error(result.message || "Failed to fetch employees.");
          return;
        }

        // Step 4: Update Local Data
        this.employees = result.employees.map(emp => ({
          id: emp.id,
          legalName: emp.legalName,
          name: emp.name,
          dob: emp.dob,
          employeeStatus: emp.employeeStatus,
          createdAt: emp.createdAt,
          updatedAt: emp.updatedAt,
          initials: emp.name
            ? emp.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
            : 'N/A',
          department: emp.department || "Unassigned",
          role: emp.position || "Unknown",
          status: emp.employeeStatus ? emp.employeeStatus.toLowerCase() : "pending",
        }));

        // Make drivers list for assignment search
        this.availableDrivers = this.employees;

        // Optional success message
        // this.toast?.success(`Fetched ${this.employees.length} employees successfully`);
      } catch (error) {
        console.error("Error fetching employees:", error);
        this.toast?.error("An error occurred while fetching employees.");
      }
    },

    /** 🔹 Select an employee */
    selectEmployee(emp) {
      console.log("Selected employee object:", emp); // debug
      if (emp && emp.id) {
        this.formData.assignedEmployees = [emp.id];  // ✅ always store ID
      }
      console.log("Assigned Employees Now:", this.formData.assignedEmployees);
      this.employeeSearch = '';
      this.filteredEmployees = [];
    },


    /** 🔹 Remove an assigned employee */
    removeEmployee() {
      this.formData.assignedEmployees = [];
      this.employeeSearch = '';
      this.filteredEmployees = this.availableDrivers;
    },

    /** 🔹 Submit Form */
    handleSubmit() {
      if (this.job) {
        this.updateJob();
      } else {
        this.addJob();
      }
    },

    /** 🔹 Add Job */
    async addJob() {
      try {
        const headers = await this.getAuthHeader();
        const payload = {
          jobId: this.formData.jobId,
          title: this.formData.title,
          client: this.formData.client,
          startLocation: this.formData.startLocation,
          endLocation: this.formData.endLocation,
          jobDate: this.formData.jobDate,
          jobStart: null, 
          jobEnd: null,
          assignedEmployees: this.formData.assignedEmployees,
          status: this.formData.status,
          description: this.formData.description,
          notifications:this.formData.notifications,
          locationBased:this.formData.locationBased,
          jobTime:this.formData.jobTime,
          department:this.formData.department,

        };

        await axios.post(`${this.apiURL}/api/jobs`, payload, { headers });

        this.onSubmit();
        this.onClose(); // close modal
      } catch (err) {
        console.error("Failed to submit job:", err);
      }
    },

    /** 🔹 Update Job */
    async updateJob() {
      try {
        const headers = await this.getAuthHeader();
        const payload = {
          title: this.formData.title,
          client: this.formData.client,
          startLocation: this.formData.startLocation,
          endLocation: this.formData.endLocation,
          jobDate: this.formData.jobDate,
          jobStart: this.formData.jobStart || null,
          jobEnd: this.formData.jobEnd || null,
          assignedEmployees: this.formData.assignedEmployees,
          status: this.formData.status,
          description: this.formData.description,
          notifications:this.formData.notifications,
          locationBased:this.formData.locationBased,
          jobTime:this.formData.jobTime,
          department:this.formData.department,

        };

        await axios.put(`${this.apiURL}/api/jobs/${this.job.id}`, payload, { headers });

        this.onSubmit(payload);
        this.onClose();
      } catch (err) {
        console.error("Failed to update job:", err);
      }
    },
    async fetchDepartments() {
      try {
        const token = await this.checkAuthState();
        const res = await axios.get(`${this.apiURL}/api/departments`, {
          headers: { Authorization: token },
        });

        if (res.data.code === 200) {
          this.departmentOptions = res.data.departments;
        } else {
          console.error("Failed to fetch departments:", res.data.message);
        }
      } catch (err) {
        console.error("Error fetching departments:", err);
      }
    },
  },

  mounted() {
    this.fetchEmployees();
    this.fetchDepartments();
  }
};
</script>

